export default function getAppVersion(): string | null {
  const versionMetaTag = document.querySelector(
    'meta[data-application-version]'
  );

  if (!versionMetaTag) {
    return null;
  }

  return versionMetaTag.getAttribute('data-application-version');
}
